import React from "react";
import { connect } from "react-redux";
import { MusicInstrumentDetailContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import { scrollToTopPageFN } from "utils/functions/scrollTopPage";
import { portalService } from "apiServices";
import { toast } from "react-toastify";
import { Displays, Forms, Modals } from "components";

class MusicInstrumentDetailContainer extends React.Component {
  state = {
    isLoading: true,
    isCreate: false,
  };

  componentDidMount() {
    const query = new URLSearchParams(this.props.router.location.search);
    const isEdit = query.get("onEdit") === "true";

    scrollToTopPageFN();
    if (isEdit) {
      this.setState({
        isEdit: true,
      });
      this.fetchData();
    } else {
      this.setState({
        isLoading: false,
      });
      this.fetchData();
    }
  }

  fetchData = async () => {
    let res = await portalService.GET_INSTRUMENT_DETAIL(
      this.props.router.params.id
    );
    if (res && res.status === 200) {
      this.setState({
        initialValues: res.data,
        isLoading: false,
      });
    }
  };

  // FLOW DELETE
  // =============================
  // =============================
  handleDelete = () => {
    this.setState({
      renderModal: (
        <Displays.CofirmBox
          label="คุณต้องการลบใช่หรือไม่ ?"
          labelBtn1="Confirm"
          labelBtn2="Cancel"
          onAction1={this.deleteAction}
          onAction2={this.handleCloseModal}
        />
      ),
    });
  };
  deleteAction = async () => {
    this.setState({
      isBgLoading: true,
    });
    let res = await portalService.DELETE_INSTRUMENT_DETAIL(
      this.props.router.params.id
    );
    if (res && res.status === 200) {
      toast.success("ลบสำเร็จ");
      this.handleNextStep();
    } else {
      toast.error("ลบไม่สำรเร็จ");
    }
  };

  handleCloseModal = () => {
    this.setState({
      renderModal: null,
    });
  };

  // FLOW SUBMIT
  // =============================
  // =============================
  handleSubmit = async (values) => {
    this.setState({
      isBgLoading: true,
    });
    let params = {
      ...values,
    };
    if (values.instrument_type_code_admin) {
      params.instrument_type_code_admin =
        values.instrument_type_code_admin.value;
      params.instrument_type_en_admin =
        values.instrument_type_code_admin.labelEn;
      params.instrument_type_th_admin =
        values.instrument_type_code_admin.labelTh;
    }
    if (values.product_code_admin) {
      params.product_code_admin = values.product_code_admin.value;
      params.product_en_admin = values.product_code_admin.labelEn;
      params.product_th_admin = values.product_code_admin.labelTh;
    }
    let res = await portalService.PUT_INSTRUMENT_UPDATE(
      this.props.router.params.id,
      params
    );
    if (res && res.status === 200) {
      toast.success("อัพเดตสำเร็จ");
      this.setState({
        isBgLoading: false,
      });
      this.handleNextStep();
    } else {
      this.setState({
        isBgLoading: false,
      });
      toast.error("อัพเดตไม่สำเร็จ");
      this.handleNextStep();
    }
  };

  handleCancel = () => {
    this.props.router.navigate(-1);
  };

  handleNextStep = () => {
    this.props.router.navigate(ROUTE_PATH.MUSIC_INSTRUMENT);
  };

  render() {
    const { authenRedux } = this.props;
    const {
      isLoading,
      initialValues,
      isBgLoading,
      renderModal,
      isCreate,
      isEdit,
    } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "reward");
    return (
      <MusicInstrumentDetailContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {isLoading ? (
          <div className="loading_show">
            <Displays.Loading theme_standard_loading />
          </div>
        ) : (
          <>
            {isCreate && <div className="title">New Reward</div>}
            <Forms.MusicInstrumentForm
              initialValues={initialValues}
              permission={permission}
              onCancel={this.handleCancel}
              onSubmit={this.handleSubmit}
              onDelete={this.handleDelete}
              isEdit={isEdit}
            />
          </>
        )}
        <Modals.BodyEmpty
          isShowModal={renderModal}
          onCloseModal={this.handleCloseModal}
        >
          {renderModal}
        </Modals.BodyEmpty>
      </MusicInstrumentDetailContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MusicInstrumentDetailContainer));
